import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import * as allShrimpJson from '../../../../data/shrimp/shrimp.json'
export const allShrimp = allShrimpJson.default

const defaultInputTankParameters = {
    gh: null,
    kh: null,
    ph: null,
}

export const store = new Vuex.Store({
    state: {
        allShrimp,
        selectedShrimpIds: [],
        inputTankParameters: Object.assign({}, defaultInputTankParameters)
    },
    mutations: {
        SET_SELECTED_SHRIMP_IDS (state, shrimpIds) {
            state.selectedShrimpIds = []

            // Ensure the shrimp ID is valid before adding it to the store
            shrimpIds.forEach(shrimpId => {
                let found = state.allShrimp.find(shrimp => {
                    return shrimp.id === shrimpId
                })

                found && state.selectedShrimpIds.push(shrimpId)
            })
        },
        SET_INPUT_TANK_PARAMETERS(state, parameters) {
            Object.assign(state.inputTankParameters, parameters)
        },
        RESET_INPUT_TANK_PARAMETERS(state) {
            Object.assign(state.inputTankParameters, defaultInputTankParameters)
        }
    },
    getters: {
        selectedShrimp: (state, getters) => {
            let returnList = []

            state.selectedShrimpIds.forEach(selectedShrimpId => {
                let foundShrimp = getters['getShrimpById'](selectedShrimpId)
                foundShrimp && returnList.push(foundShrimp)
            })

            return returnList
        },
        getShrimpById: state => shrimpId => {
            return state.allShrimp.find(shrimp => {
                return shrimp.id === shrimpId
            })
        },
        getSummaryUri: (state, getters) => {
            let waterParams = 'auto'

            if(getters['hasInputParameters']) {
                waterParams = [
                    state.inputTankParameters.gh,
                    state.inputTankParameters.kh,
                    state.inputTankParameters.ph,
                ].join(',')
            }
            let shrimpIdsCsv = state.selectedShrimpIds.join(',')

            return '/summary/' + waterParams + '/' + shrimpIdsCsv
        },
        hasInputParameters: state => {
            return state.inputTankParameters.gh !== null
                && state.inputTankParameters.kh !== null
                && state.inputTankParameters.ph !== null
        },
        inputParameters: state => {
            return {
                gh: [state.inputTankParameters.gh, state.inputTankParameters.gh],
                kh: [state.inputTankParameters.kh, state.inputTankParameters.kh],
                ph: [state.inputTankParameters.ph, state.inputTankParameters.ph]
            }
        },
        shrimpImageUri: () => shrimpId => {
            return process.env.BASE_URL + 'images/shrimp/' + shrimpId + '.png'
        },
        defaultImageUri: () => {
            return process.env.BASE_URL + 'images/shrimp/default.png'
        }
    }
})